import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const AppleSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setTokens } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const error = searchParams.get('error');
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh');

    if (error) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }

    if (token && refreshToken) {
      try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));

        setTokens(token, refreshToken);
        window.location.replace(payload.needsOnboarding ? '/create-companion' : '/dashboard');
      } catch {
        setTokens(token, refreshToken);
        window.location.replace('/dashboard');
      }
    } else {
      navigate('/login?error=oauth_failed', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-dark-bg dark:bg-dark-bg bg-light-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 bg-black rounded-3xl mx-auto mb-4 flex items-center justify-center">
          <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-dark-text dark:text-dark-text text-light-text">
          {t('auth.completingSignIn', 'Completing sign in...')}
        </h1>
        <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mt-2">
          {t('auth.settingUpAccount', 'Please wait while we finish setting up your account.')}
        </p>
      </div>
    </div>
  );
};

export default AppleSuccess;
